<template>
    <div class="filter-results" :class="{ 'filter-results-loading': this.filter_loading }">

        


        <!-- Pagination row - with total results and selection dropdown -->
        <div class="row align-items-center pt-2 pb-2" v-if="singleadid == null">
            <div class="col-md-3" v-if="number_of_results">
                <div class="results-count"><b>Totali: {{ number_of_results.toLocaleString('it') }}</b></div>
            </div>

            <div class="col-md-3" v-if="number_of_results == 0">
                <div class="results-count"><b>0 Risultati</b></div>
            </div>

            <div class="col-md-6" v-if="number_of_results">
                <!-- Pagination for items -->
                <div class="row pagination-row align-items-center" v-if="totalPages > 1">
                    <div class="col-12">
                        <!-- <ul class="pagination-list">
                            <li v-for="pageNumber in totalPages" :key="pageNumber">
                                <a @click="goToPage(pageNumber)" :class="{ 'active': page == pageNumber }">{{ pageNumber }}</a>
                            </li>
                        </ul> -->

                        <ul class="pagination-list">

                            <li v-if="page > 1" class="icon-pagination prev-page">
                                <a title="Previous page" @click="goToPage(page - 1)"><i class="la la-angle-left"></i></a>
                            </li>

                            <!-- Display the first page number -->
                            <li v-if="page > 1">
                                <a @click="goToPage(1)">1</a>
                            </li>

                            <!-- Display dots if there are more than two pages before the current page -->
                            <li v-if="page > 3" class="pagination-dots">...</li>

                            <!-- Display the two pages before the current page -->
                            <li v-for="i in pagesBefore" :key="i">
                                <a class="page-num-a" @click="goToPage(i)">{{ i }}</a>
                            </li>

                            <!-- Display the current page with 'active' class -->
                            <li>
                                <a :class="{ 'active': true }">{{ page }}</a>
                            </li>

                            <!-- Display the two pages after the current page -->
                            <li v-for="i in pagesAfter" :key="i">
                                <a @click="goToPage(i)" :class="{ 'active': i === page }">{{ i }}</a>
                            </li>

                            <!-- Display dots if there are more than two pages after the current page -->
                            <li v-if="page < totalPages - 2" class="pagination-dots">...</li>

                            <!-- Display the last page number -->
                            <li v-if="page < totalPages ">
                                <a @click="goToPage(totalPages)">{{ totalPages }}</a>
                            </li>

                            <li v-if="page < totalPages" class="icon-pagination next-page">
                                <a title="Next page" @click="goToPage(page + 1)"><i class="la la-angle-right"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-3" v-if="number_of_results">
                <div class="number-of-pages-wrapper">
                    <div class="pf-field">
                        <label class="pf-label" for="number-records-select1">per pagina</label>
                        <select class="number-records-select" id="number-records-select1" v-model="perPage" @change="updateNumberOfRecords" placeholder="Number of records">
                            <option value="10" selected>10 per pagina</option>
                            <option value="25">25 per pagina</option>
                            <option value="50">50 per pagina</option>
                            <option value="100">100 per pagina</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
       

        <ads-list-entry
            v-cloak
            v-for="ads in adsList"
            :key="ads.id"
            :isPanelVisible="ads.id === activeChildIndex || !!singleadid" 
            @updatevisible="updatevisible"
            v-bind:ads="ads"
            :singleadid="singleadid"
            :authid="authid"
            :professionalid="professionalid"
            :professionalcompleted="professionalcompleted"
            :showonhome="showonhome"
        >
        </ads-list-entry>

        <!-- Pagination row - with total results and selection dropdown -->
        <div class="row align-items-center pt-2 pb-2" v-if="singleadid == null">
            <div class="col-md-3" v-if="number_of_results">
                <div class="results-count"><b>Totali: {{ number_of_results.toLocaleString('it') }}</b></div>
            </div>

            <div class="col-md-6" v-if="number_of_results">
                <!-- Pagination for items -->
                <div class="row pagination-row align-items-center" v-if="totalPages > 1">
                    <div class="col-12">
                        <!-- <ul class="pagination-list">
                            <li v-for="pageNumber in totalPages" :key="pageNumber">
                                <a @click="goToPage(pageNumber)" :class="{ 'active': page == pageNumber }">{{ pageNumber }}</a>
                            </li>
                        </ul> -->

                        <ul class="pagination-list">

                            <li v-if="page > 1" class="icon-pagination prev-page">
                                <a title="Previous page" @click="goToPage(page - 1)"><i class="la la-angle-left"></i></a>
                            </li>

                            <!-- Display the first page number -->
                            <li v-if="page > 1">
                                <a @click="goToPage(1)">1</a>
                            </li>

                            <!-- Display dots if there are more than two pages before the current page -->
                            <li v-if="page > 3" class="pagination-dots">...</li>

                            <!-- Display the two pages before the current page -->
                            <li v-for="i in pagesBefore" :key="i">
                                <a class="page-num-a" @click="goToPage(i)">{{ i }}</a>
                            </li>

                            <!-- Display the current page with 'active' class -->
                            <li>
                                <a :class="{ 'active': true }">{{ page }}</a>
                            </li>

                            <!-- Display the two pages after the current page -->
                            <li v-for="i in pagesAfter" :key="i">
                                <a @click="goToPage(i)" :class="{ 'active': i === page }">{{ i }}</a>
                            </li>

                            <!-- Display dots if there are more than two pages after the current page -->
                            <li v-if="page < totalPages - 2" class="pagination-dots">...</li>

                            <!-- Display the last page number -->
                            <li v-if="page < totalPages ">
                                <a @click="goToPage(totalPages)">{{ totalPages }}</a>
                            </li>

                            <li v-if="page < totalPages" class="icon-pagination next-page">
                                <a title="Next page" @click="goToPage(page + 1)"><i class="la la-angle-right"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-3" v-if="number_of_results">
                <div class="number-of-pages-wrapper">
                    <div class="pf-field">
                        <label class="pf-label" for="number-records-select2">per pagina</label>
                        <select class="number-records-select" id="number-records-select2" v-model="perPage" @change="updateNumberOfRecords" placeholder="Number of records">
                            <option value="10" selected>10 per pagina</option>
                            <option value="25">25 per pagina</option>
                            <option value="50">50 per pagina</option>
                            <option value="100">100 per pagina</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import { EventBus } from '../event-bus';
    export default {
        name: "ads-list",
        props: {
            addressmaster: {
                type: Array, 
                required: false,
                default: function(){
                  return [];  
                }
            }, 
            singleadid: {
                type: Number, 
                required: false,
                default: function(){
                  return null;  
                }
            },
            authid: {
                type: String, 
                required: false,
                default: function(){
                  return null;  
                }
            },
            professionalid: {
                type: Number, 
                required: false,
                default: function(){
                  return null;  
                }
            },

            professionalcompleted: {
                type: Boolean, 
                required: false,
                default: function(){
                  return false;  
                }
            },

            showonhome: {
                type: Boolean, 
                required: false,
                default: function(){
                  return false;  
                }
            }
        },
        data () {



            return {
                adsList: [],
                activeChildIndex: null,
                number_of_results: 0,
                filter_loading: false,

                // Pagination data
                pagedFilterParams: undefined,
                perPage: 10,      // Items per page
                page: 1,     // Current page

    
            }
        },
        mounted() {
            
            // Call the filter method
            let _this = this;


            document.addEventListener('rememberOpenedId', function(event) {
                console.log(_this.activeChildIndex);

                if ( _this.activeChildIndex ) {
                    sessionStorage.setItem('visible_ad', _this.activeChildIndex);
                } else {
                    sessionStorage.setItem('visible_ad', null);
                }
                
            });



            // Search Ads filter event
            this._filtersAppliedHandler = (event) => {
                // Handle the event
                //console.log('Filter Event Triggered: ', event);

                // When the event is triggered initiate the filters
                let filters = event?.filter_data;
                this.filter(filters);
            };
            EventBus.$on('filtersApplied', this._filtersAppliedHandler);


            // If the URL doesn't have perPage set then only default it to 10
            const urlParams = new URLSearchParams(window.location.search);
            let urlPerPageParam = urlParams.getAll('perPage');
            // Send request to get update from filters
            this.perPage = urlPerPageParam.length ? urlPerPageParam[0] : this.perPage;

            /*
            const customEvent = new CustomEvent('filtersApply', { detail: {page: this.page, perPage: this.perPage } });
            // Dispatch the event
            document.dispatchEvent(customEvent);
            */

            // Emit event to notify the search component about page parameters
            EventBus.$emit('filtersApply', { page: this.page, perPage: this.perPage });

            if ( this.singleadid ) {
                // alert( 'Single Ad id of : ' + this.singleadid );
                _this.filter({id: this.singleadid });
            }

            // Tooltip
            window.setTimeout(function(){
                jQuery(".tsw-ad-entry [data-bs-toggle='tooltip']").tooltip();
            }, 500);

        },

        beforeUnmount() {
            if (this._filtersAppliedHandler) {
                EventBus.$off('filtersApplied', this._filtersAppliedHandler);
            }
        },

        methods: {

            toolipReset(){
                window.setTimeout(function(){
                    jQuery(".entry-item-inner [data-bs-toggle='tooltip']").tooltip('dispose')                 
                    jQuery(".entry-item-inner [data-bs-toggle='tooltip']").tooltip();
                }, 100);
            }, 

            filter: function(filters){

                // On filter change activeIndex to null
                this.activeChildIndex = null;

                /*
                this.$apiClient.getAdsList(filters)
                .then(response => {
                    this.adsList = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
                */
                this.filter_loading = true;
                
                // Set the paged filter data param
                this.pagedFilterParams = filters;

                this.$apiClient.getFilteredAdsList(this.pagedFilterParams, this.singleadid)
                .then(response => {
                    this.adsList = response.data.data;

                    const addressMasterData = this.addressmaster;

                    // Loop through each item in this.adsList
                    this.adsList.forEach(ad => {
                        // Check if 'province' key exists in the current item and if a value exists
                        if (ad.hasOwnProperty('province') && ad.province !== null) {
                            // Find the corresponding item in addressmaster using the province value
                            const matchingAddress = addressMasterData.find(addr => addr.province === ad.province);
                            // If a matching address is found, update the 'province' key with 'province_code'
                            if (matchingAddress && matchingAddress.hasOwnProperty('province_code')) {
                                ad.province_label = `${ad.province} (${matchingAddress.province_code})`;
                            } else {
                                ad.province_label = `${ad.province}`;
                            }
                        }
                    });

                    if ( response?.data?.total ) {
                        this.number_of_results = response?.data?.total;
                        this.page = response.data.page;
                        this.perPage = response.data.perPage;
                    } else {
                        this.number_of_results = 0;
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(()=>{

                    this.toolipReset();

                    this.filter_loading = false;

    

                    // Scroll to the visible box if available
                    let visibleAdEntry = $('.tsw-ad-entry.is-panel-visible');
                    let isSingleAd = $('.ads-details-panel.single-ad').length;

                    if ( visibleAdEntry.length && !isSingleAd ) {
                        $('html, body').animate({
                            scrollTop: $('.tsw-ad-entry.is-panel-visible').offset().top - 100
                        }, 1000); // Adjust the duration (1000 ms) as needed
                    } else {
                        // After applying filters scroll to top
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                })
            },
            updatevisible(index) {
                console.log('Ad list: Update visible index: ', index, this.adsList);
                if ( this.activeChildIndex === index ) {
                    sessionStorage.setItem('visible_ad', null);
                }

                // Just once to open an ad
                if ( sessionStorage.getItem('visible_ad') ) {
                    sessionStorage.setItem('visible_ad', null);
                }
                

                this.activeChildIndex = (this.activeChildIndex === index) ? null : index;


                try {
                    if (typeof gtag === "function" && this.activeChildIndex !== null) {
                        let matchedAd = this.adsList.find(item => item.id === index);
                        if (matchedAd) {
                            var aditemobj = {
                                item_list_id: "ads_list",
                                item_list_name: "Ads List",
                                items: [
                                    {
                                        item_id: `${matchedAd.id}`,
                                        item_name: `${matchedAd.title}`,
                                        affiliation: `business_${matchedAd.business_id}`,
                                        location_id: `${matchedAd.business_location_id}`,
                                        index: index,
                                        item_category: "Ads",
                                        item_variant: "default",
                                        quantity: 1
                                    }
                                ]
                            };
                            gtag("event", "select_item", aditemobj);
                        } else {
                            console.log('No matching ad found for ID:', index);
                        }
                    }
                } catch (error) {
                    console.error('Error in gtag event tracking:', error);
                }
                
                
            },
            goToPage(page) {
                // Fetch data for the selected page
                this.page = page;
                
                // this.filter( this.pagedFilterParams );

                /*
                const customEvent = new CustomEvent('filtersApply', { detail: { page: this.page, perPage: this.perPage } } );
                document.dispatchEvent(customEvent);
                */
                EventBus.$emit('filtersApply', { page: this.page, perPage: this.perPage });
            },

            updateNumberOfRecords(){
                this.page = 1;
                /*
                const customEvent = new CustomEvent('filtersApply', { detail: { page: this.page, perPage: this.perPage } } );
                document.dispatchEvent(customEvent);
                */
                EventBus.$emit('filtersApply', { page: this.page, perPage: this.perPage });
            }
            
        },

        computed: {
            totalPages() {
                return Math.ceil(this.number_of_results / this.perPage);
            },
            pagesBefore() {
                return [this.page - 2, this.page - 1].filter(i => i > 1);
            },
            pagesAfter() {
                return [this.page + 1, this.page + 2].filter(i => i <= this.totalPages && i !== this.totalPages);
            }
        }
    }
</script>

<style scoped>

.filter-results.filter-results-loading {
    opacity: 1;
    
}

.filter-results.filter-results-loading::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 200px;
    background: url('/public/img/loading-80x.gif'); 
    min-height: 100vh;
    background-repeat: no-repeat;
    background-position: top 10vh center;
    background-size: 72px;
    background-position: top 20vh center;
    background-color: rgba(255,255,255,0.75);
    z-index: 99;

}

</style>
